/**
 * The legal documents the app links to and the words of the beta's prompts, from
 * packages/legal/manifest.json, the file the API records each yes against (apps/api/src/legal.ts).
 * A new version of a document goes there: packages/legal/README.md.
 */
import manifest from "../../../../packages/legal/manifest.json";

export type DocumentKind = "beta_terms" | "privacy";
export interface LegalDocument { title: string; version: string; effective: string; url: string }
/** `{beta_terms}` and `{privacy}` in the words are links to those documents (components/Legal.tsx). */
export interface Prompt { documents: DocumentKind[]; text: string; lead?: string; question?: string; note?: string }

export const DOCS = manifest.documents as Record<DocumentKind, LegalDocument>;
const PROMPTS = manifest.prompts as Record<string, Prompt>;

export const TERMS_PROMPT = PROMPTS["beta.terms.v6"]!;
export const MINORS_PROMPT = PROMPTS["beta.minors.v1"]!;
export const SOCIAL_PROMPT = PROMPTS["beta.social.v6"]!;
